/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  EditPrinterDTO,
  EditPrinterDTOOptional,
  EditPrinterDTOMetaI,
  EditPrinterDTOTrackedI,
} from "./edit-printer-dto";
import { EditPrinterDTOTracked, EditPrinterDTOMeta } from "./edit-printer-dto";

/**
 *
 * @export
 * @interface EditPrintersDTO
 */
export interface EditPrintersDTOOptional {
  /**
   *
   * @type {Array<EditPrinterDTO>}
   * @memberof EditPrintersDTO
   */
  printersEdited?: EditPrinterDTOOptional[];
}

export interface EditPrintersDTO extends EditPrintersDTOOptional {
  /**
   *
   * @type {Array<EditPrinterDTO>}
   * @memberof EditPrintersDTO
   */
  printersEdited?: EditPrinterDTO[];
}

export interface EditPrintersDTOTrackedI {
  /**
   *
   * @type {Array<EditPrinterDTO>}
   * @memberof EditPrintersDTO
   */
  printersEdited?: EditPrinterDTOTrackedI[];
  printersEditedIsSet: boolean;
}

transformDatesMap.set("EditPrintersDTO", function (model: EditPrintersDTO) {
  const transformDatesprintersEdited = transformDatesMap.get("EditPrinterDTO");
  if (transformDatesprintersEdited) {
    model.printersEdited?.forEach((sub) => {
      transformDatesprintersEdited(sub);
    });
  }
});

export type EditPrintersDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  printersEdited: PropertyMeta<EditPrinterDTOMetaI>;
}>;

export var EditPrintersDTOMeta: EditPrintersDTOMetaI =
  {} as EditPrintersDTOMetaI;
EditPrintersDTOMeta = typeMeta("EditPrintersDTO", {
  printersEdited: propertyMeta(
    "printersEdited",
    true,
    false,
    false,
    EditPrinterDTOMeta,
  ),
});

const metaI = EditPrintersDTOMeta;

registerMeta(() => {});

export class EditPrintersDTOTracked implements EditPrintersDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  printersEdited__I?: EditPrinterDTOTracked[] = undefined;
  printersEditedIsSet: boolean = false;
  set printersEdited(v: undefined | EditPrinterDTOTracked[]) {
    if (v !== undefined) {
      this.printersEdited__I = v;
      this.printersEditedIsSet = true;
    } else {
      this.printersEdited__I = v || undefined;
      this.printersEditedIsSet = false;
    }
    this.changeTracker = true;
  }
  get printersEdited() {
    return this.printersEdited__I;
  }
  constructor(config?: EditPrintersDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.printersEdited?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: EditPrintersDTOOptional,
    options?: AssignOptions,
  ): EditPrintersDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.printersEdited &&
      this.printersEditedApplyFilter(optionsRequired.filter)
    ) {
      this.printersEdited = config.printersEdited?.map(
        (a) => new EditPrinterDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.printersEditedIsSet = false;
      else this.printersEditedIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EditPrintersDTOTrackedI {
    const cloned = {} as EditPrintersDTOTrackedI;
    if (
      this.printersEditedIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.printersEditedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printersEditedIsSet = true;
      cloned.printersEdited = this.printersEdited
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.printersEditedIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EditPrintersDTOTrackedI {
    if (!this.printersEditedApplyFilter(filter))
      this.printersEditedIsSet = false;

    this.printersEdited?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  printersEditedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrintersDTOMeta.printersEdited,
      EditPrintersDTOMeta,
      this.printersEdited,
      this,
    );
  }
  printersEditedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printersEditedIsSet && this.printersEditedApplyFilter(filter))
      return true;

    return this.printersEdited?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.printersEditedIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
